import { YOO_FINDS_CDN } from "@/common";

const baseUrl = `${YOO_FINDS_CDN}/pc/black5`;
export const Black5BannerSrc = `${baseUrl}/black5-pc-big-sale.png`;
export const GiftBGSrc = `${baseUrl}/bg-gift.png`;
export const Black5IconSrc = `${baseUrl}/black5-icon.png`;
export const ShippingIconSrc = `${baseUrl}/shipping-icon.png`;
export const TitleBg1 = `${baseUrl}/independent-title-bg1.png`;
export const TitleBg2 = `${baseUrl}/independent-title-bg2-v2.png`;
export const TitleBg3 = `${baseUrl}/independent-title-bg3-v2.png`;
export const TitleBg4 = `${baseUrl}/independent-title-bg4-v2.png`;
